import * as React from 'react';

export type IntensityProps = {
	label?: string;
	value: number;
	modifier?: string;
};

export type IntensityList = [boolean, boolean, boolean];

/**
 * Maximum intensity level, equals four.
 */
const MAX_VALUE = 3;

/*
 * Converts numberal intensity value into visual values (array with booleans)
 * @param  {string} value 			levels to fill
 * @return {IntensityList}			List format
 */
const _convertIntesityValueToVisualValues = (value: string | number): IntensityList => {
	const fillAmount: number = typeof value === 'string' ? parseInt(value, 10) : value;
	const visualValues: IntensityList = [false, false, false];

	if (fillAmount > MAX_VALUE || fillAmount < 0) {
		return visualValues;
	}

	visualValues.fill(true, 0, fillAmount);

	return visualValues;
};

const Intensity = ({ label, modifier, value }: IntensityProps) => {
	const values = _convertIntesityValueToVisualValues(value);

	const renderIntensityItems = (allValues: boolean[]) => {
		return allValues.map((isActive: boolean, index: number) => {
			return <li key={index} className={`a-intensity__item${isActive ? ' a-intensity__item--filled' : ''}`} />;
		});
	};

	return (
		<div className={`a-intensity${modifier ? ` a-intensity--${modifier}` : ''}`}>
			{label && <span className="a-intensity__label">{label}</span>}
			<ul className="a-intensity__list">{renderIntensityItems(values)}</ul>
		</div>
	);
};

export default Intensity;
